export const AUMacro = [
    {
        key: 'state',
        label: 'State',
    },
    {
        key: 'sa3',
        label: 'SA3',
    },
    {
        key: 'sa1',
        label: 'SA1',
    },
    {
        key: 'ce',
        label: 'Federal Electorate',
    },
    {
        key: 'sa2',
        label: 'SA2',
    },
    {
        key: 'mb',
        label: 'Meshblock',
    },
    {
        key: 'se',
        label: 'State Electorate',
    },
    {
        key: 'suburb',
        label: 'Suburb',
    },
    {
        key: 'sa4',
        label: 'SA4',
    },
    {
        key: 'postcode',
        label: 'Postcode',
    },
];

export const NZBoundaries = [];


// WEBPACK FOOTER //
// ./src/shared/helpers/boundaries.js